(() => {
  const dialog = document.getElementById('bfc-eu-notice');
  if (!dialog || typeof dialog.showModal !== 'function' || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const closeButton = dialog.querySelector('[data-bfc-eu-close]');
  const fitButton = dialog.querySelector('[data-bfc-eu-fit]');
  const body = dialog.querySelector('[data-bfc-eu-body]');
  const poster = dialog.querySelector('#bfc-eu-notice-poster');
  const help = dialog.querySelector('[data-bfc-eu-scroll-help]');
  let opener;
  let pausedTrap;
  let backdropPointer = false;

  function setFit(fit) {
    dialog.toggleAttribute('data-fit', fit);
    fitButton.setAttribute('aria-pressed', String(fit));
    fitButton.textContent = fit ? 'Lesbare Originalgröße' : 'Gesamtansicht';
    help.hidden = fit;
    poster.scrollLeft = 0;
    body.scrollTop = 0;
  }
  function enhance(root = document) {
    root.querySelectorAll('[data-bfc-eu-open]').forEach((link) => {
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-controls', dialog.id);
    });
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-bfc-eu-open]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (dialog.open) { event.preventDefault(); return; }
    opener = link;
    // Stretch drawers trap focus independently of native dialog. Pause, never close, the parent.
    const host = link.closest('cart-drawer[open], x-drawer[open], x-modal[open]');
    const trap = host?.focusTrap;
    if (trap?.active && !trap.paused) { trap.pause(); pausedTrap = trap; }
    try {
      setFit(false);
      dialog.showModal();
      event.preventDefault();
      document.documentElement.classList.add('bfc-eu-notice-open');
      closeButton.focus({ preventScroll: true });
      // Reset visible scroll containers; resets while the dialog is hidden may be ignored.
      body.scrollTop = 0;
      poster.scrollTop = 0;
      poster.scrollLeft = 0;
    } catch {
      pausedTrap?.unpause();
      pausedTrap = undefined;
      // Preserve the real image link if the native viewer cannot open.
    }
  });
  closeButton.addEventListener('click', () => dialog.close());
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); dialog.close(); });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('bfc-eu-notice-open');
    pausedTrap?.unpause();
    pausedTrap = undefined;
    if (opener?.isConnected && opener.getClientRects().length) opener.focus({ preventScroll: true });
    setFit(false);
  });
  function isBackdrop(event) {
    const rect = dialog.getBoundingClientRect();
    return event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
  }
  dialog.addEventListener('pointerdown', (event) => { backdropPointer = isBackdrop(event); });
  dialog.addEventListener('click', (event) => {
    if (backdropPointer && isBackdrop(event)) dialog.close();
    backdropPointer = false;
  });
  fitButton.addEventListener('click', () => setFit(!dialog.hasAttribute('data-fit')));
  dialog.querySelector('[data-bfc-eu-read]').addEventListener('click', (event) => {
    event.preventDefault();
    const heading = dialog.querySelector('#bfc-eu-notice-text');
    heading.focus({ preventScroll: true });
    // Scroll only this viewer, not the page or the parent cart behind it.
    body.scrollTop += heading.getBoundingClientRect().top - body.getBoundingClientRect().top - 24;
  });
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
  enhance();
})();

